import React from 'react'

// redux
import { connect } from "react-redux";

// styles
import ModalContainer from '../../styles/Modal/ModalStyles'

// icons
import { BiCheck, BiPlus, BiX } from "react-icons/bi";

function AddressesModal(props) {
    // props
    const {
        selectedAddressId,
        userAddress,
        chooseAddress,

        email,
        commonToken,

        closeModal,

        title,
        description
    } = props

    return (
        <ModalContainer className="choose-address-modal position-relative">

            {/* close icon */}
            <div
                className="modal-close-icon cursor-pointer position-absolute"
                style={{ top: -3, right: 0 }}
                onClick={closeModal}>
                <BiX fontSize={23} />
            </div>

            {/* header */}
            <div className="head-container mb-3">
                <p className="head st-fw-800 st-fs-20 mb-0 text-capitalize">{title ?? 'Addresses'}</p>
                <p className="desc mb-0">{description ?? "Choose your address"}</p>
            </div>

            {/* adderss view */}
            <div className="addresses-view d-flex flex-wrap">
                {
                    userAddress?.length ? userAddress.map(item => {
                        return (
                            <div key={item.addressId} className="address-item">
                                <div className="inner d-flex flex-column">
                                    {
                                        item.isDefault === "1" ? (
                                            <p className="is-default mb-1 st-fs-12">Default</p>
                                        ) : null
                                    }
                                    <p className="name st-fw-700 mb-1">{item.firstName} {item.lastName}</p>
                                    <p className="address st-fs-13 name mb-1">{item.address}</p>
                                    <p className="st-fs-13 address-details mb-1">
                                        {item.cityName}, {item.stateName} {item.zipCode}
                                    </p>
                                    <p className="st-fs-13 country mb-1">
                                        {item.countryName}
                                    </p>
                                    <p className="st-fs-13 phone mb-2">
                                        {item.phone}
                                    </p>
                                    <button
                                        className="btn d-flex align-items-center justify-content-center"
                                        disabled={selectedAddressId === item.addressId}
                                        onClick={ev => {
                                            ev.preventDefault()
                                            chooseAddress(item)
                                        }}>
                                        {
                                            selectedAddressId === item.addressId ? (
                                                (
                                                    <React.Fragment>
                                                        <BiCheck fontSize="16" />
                                                        <span className="ms-1">Selected</span>
                                                    </React.Fragment>
                                                )
                                            ) : "Choose Address"
                                        }
                                    </button>
                                </div>
                            </div>
                        )
                    }) : null
                }

                {/* add new address */}
                <div className="address-item add-new-address">
                    <div className="inner d-flex flex-column align-items-center justify-content-center cursor-pointer" onClick={ev => {
                        ev.preventDefault()
                        chooseAddress("")
                    }}>
                        <BiPlus fontSize="20" />
                        <span className="mt-2">Add new address</span>
                    </div>
                </div>
                {/* <div className="w-100 ">
                </div> */}
            </div>

        </ModalContainer>
    )
}


const getDataFromStore = (state) => {
    return {
        tempOrderId: state.auth.tempOrderId,
        commonToken: state.auth.commonToken,
    };
};

export default connect(getDataFromStore, null)(AddressesModal);